<template>
	<RadioGroup
		v-model="val"
		class="-space-y-px rounded-md bg-white"
		@update:model-value="updateValue">
		<RadioGroupOption
			v-for="(option, index) in options"
			:key="option.name"
			v-slot="{ active, checked }"
			:value="option.name"
			:aria-label="option.name"
			as="template">
			<div
				:class="[
					index === 0 ? firstClasses : '',
					index === options.length - 1 ? lastClasses : '',
					checked ? checkedOption : 'border-gray-200',
					optionClasses
				]">
				<span
					:class="[
						checked ? 'border-transparent bg-mabey-600' : 'border-gray-300 bg-white',
						active ? 'ring-2 ring-mabey-600 ring-offset-2' : '',
						optionBulletClasses
					]"
					aria-hidden="true">
					<span class="h-1.5 w-1.5 rounded-full bg-white" />
				</span>
				<span class="ml-3 flex flex-col">
					<span
						:class="[checked ? 'text-mabey-900' : 'text-gray-900', optionTextClasses]">
						{{ option.name }}
					</span>
				</span>
			</div>
		</RadioGroupOption>
	</RadioGroup>
</template>

<script lang="ts" setup>
	import { RadioGroup, RadioGroupOption } from '@headlessui/vue'
	import { onMounted, ref } from 'vue'

	type RadioOption = {
		name: string
		value: number | string
	}

	const props = withDefaults(
		defineProps<{
			modelValue?: any
			options: RadioOption[]
		}>(),
		{
			modelValue: undefined
		}
	)

	const val = ref()

	const firstClasses = 'rounded-tl-md rounded-tr-md'
	const lastClasses = 'rounded-bl-md rounded-br-md'
	const optionClasses = 'relative flex cursor-pointer border px-4 py-3 focus:outline-none'
	const checkedOption = 'z-10 border-mabey-200 bg-mabey-50'
	const optionBulletClasses =
		'mt-0.5 flex h-4 w-4 shrink-0 cursor-pointer items-center justify-center rounded-full border'
	const optionTextClasses = 'block text-sm font-medium'

	// Events
	const emit = defineEmits(['update:modelValue'])
	function updateValue(value: any) {
		emit('update:modelValue', value)
	}

	onMounted(() => {
		val.value = props.modelValue
	})
</script>
